import styled from "styled-components";

import { useT } from "./i18n";

// Payment / deposit status as a coloured badge. Extracted from BookingDrawer so the payment dialog
// renders the SAME badge for the same status — two spellings of one status is how a front desk ends
// up believing a payment is in two states at once.
const StatusChip = styled.span`
  align-items: center;
  background: ${(props) => props.$bg};
  border-radius: 999px;
  color: ${(props) => props.$fg};
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.1rem 0.5rem;
`;

const PAYMENT_STATUS_META = {
  paid: { key: "pay_paid", bg: "#dcfce7", fg: "#166534" },
  pending: { key: "pay_pending", bg: "#fef3c7", fg: "#92400e" },
  pending_payment: { key: "pay_pending", bg: "#fef3c7", fg: "#92400e" },
  expired: { key: "pay_expired", bg: "#f1f5f9", fg: "#475569" },
  failed: { key: "pay_failed", bg: "#fee2e2", fg: "#991b1b" },
  canceled: { key: "pay_canceled", bg: "#f1f5f9", fg: "#475569" },
  unpaid: { key: "pay_unpaid", bg: "#f1f5f9", fg: "#475569" },
};

export const paymentStatusMeta = (status) =>
  PAYMENT_STATUS_META[status] || { key: null, bg: "#f1f5f9", fg: "#475569" };

const PayBadge = (props) => {
  const { t } = useT();
  const meta = paymentStatusMeta(props.status);
  return (
    <StatusChip $bg={meta.bg} $fg={meta.fg}>
      {meta.key ? t(meta.key) : String(props.status || "").replace(/_/g, " ")}
    </StatusChip>
  );
};

export default PayBadge;
